/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Theme, useTheme, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { SubmitButton } from 'components/form'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { ProcedimentoOdontoSelectModel } from 'components/form/field/select/ProcedimentoOdontoSelectField'
import boca from 'images/atendimento/boca_tecidos_moles.svg'
import { useMemo } from 'react'
import { MetaPath } from 'util/metaPath'
import { RowType, useEditableListField } from 'view/atendimentos/detail/components/EditableList'

import { CaracteristicasLesaoFieldModel } from './components/caracteristicas-lesao/CaracteristicasLesaoField'
import { LocalTecidosMolesFieldModel } from './components/LocalTecidosMolesField'
import TecidosMolesForm from './TecidosMolesForm'
import TecidosMolesFormFields from './TecidosMolesFormFields'
import TecidosMolesTable from './TecidosMolesTable'

export interface TecidosMolesFieldModel extends RowType {
  local: LocalTecidosMolesFieldModel
  problema?: CidSelectFieldModel
  caracteristicasLesao?: CaracteristicasLesaoFieldModel
  procedimentos?: ProcedimentoOdontoSelectModel[]
  observacao?: string
}

export interface TecidosMolesFieldProps {
  name: MetaPath<TecidosMolesFieldModel[]>
  cidadaoDataNascimento: LocalDate
}

export default function TecidosMolesField(props: TecidosMolesFieldProps) {
  const { name, cidadaoDataNascimento } = props

  const theme = useTheme()
  const classes = useMemo(() => styles(theme), [theme])

  const {
    handleSubmit,
    handleRowChanged,
    removeItem,
    input: { value },
  } = useEditableListField<TecidosMolesFieldModel>({
    name,
  })

  return (
    <VFlow>
      <HFlow style={classes.hFlow}>
        <img height={320} src={boca} alt='Boca de Tecidos Moles' css={classes.boca} />

        <Box>
          <TecidosMolesForm
            onSubmit={handleSubmit}
            render={(formProps) => (
              <VFlow>
                <TecidosMolesFormFields
                  parteBucalSelecionada={formProps.values?.local?.value}
                  cidadaoDataNascimento={cidadaoDataNascimento}
                  hasProcedimentos={formProps.values?.procedimentos?.length > 0}
                  disableProblemas={!formProps.values?.local}
                />

                <HFlow justifyContent='flex-end'>
                  <SubmitButton size='small' kind='primary' handleSubmit={formProps.handleSubmit}>
                    Adicionar
                  </SubmitButton>
                </HFlow>
              </VFlow>
            )}
          />
        </Box>
      </HFlow>

      {value.length > 0 && (
        <TecidosMolesTable
          items={value}
          cidadaoDataNascimento={cidadaoDataNascimento}
          updateItem={handleRowChanged}
          removeItem={removeItem}
        />
      )}
    </VFlow>
  )
}

const styles = (theme: Theme) => ({
  hFlow: css`
    ${theme.breakpoints.down('lg')} {
      grid-auto-flow: row;
    }
  `,
  boca: css`
    ${theme.breakpoints.down('xl')} {
      height: 17rem;
    }
    ${theme.breakpoints.down('lg')} {
      height: 15rem;
    }
  `,
})
